import type { TerritoryTis } from '@disco/types/types/rights-data'

export type Territory = {
  tis: TerritoryTis
  code: string
  short: string
  name: string
}

export const TERRITORIES: readonly Territory[] = [
  { tis: '840', code: 'US', short: 'US', name: 'United States' },
  { tis: '36', code: 'AU', short: 'AU', name: 'Australia' },
  { tis: '392', code: 'JP', short: 'JPN', name: 'Japan' },
  { tis: '826', code: 'UK', short: 'UK', name: 'United Kingdom' },
] as const

export const TERRITORY_BY_TIS: Record<TerritoryTis, Territory> =
  Object.fromEntries(TERRITORIES.map(t => [t.tis, t])) as Record<
    TerritoryTis,
    Territory
  >
